(function () {
  if (window.ucImagePerformanceLoaded) return;
  window.ucImagePerformanceLoaded = true;

  var frame = null;
  var drawerSelector = '#halo-cart-sidebar';
  var shopifyImagePattern = /cdn\.shopify\.com\/s\/files\/|\/cdn\/shop\/files\//;

  function cleanUrl(url) {
    if (!url) return '';
    var value = String(url).trim().split(/\s+/)[0];
    if (!value || value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) return '';
    value = value.replace(/&amp;/g, '&');
    value = value.replace(/([?&])width=\d+(&?)/, function (match, prefix, suffix) {
      return suffix ? prefix : '';
    });
    value = value.replace(/[?&]$/, '');
    if (value.indexOf('//') === 0) value = window.location.protocol + value;
    return value;
  }

  function canResize(url) {
    return shopifyImagePattern.test(url || '');
  }

  function sizedUrl(url, width) {
    var clean = cleanUrl(url);
    if (!clean || !canResize(clean)) return clean;
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcset(url, widths) {
    return widths.map(function (width) {
      return sizedUrl(url, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function currentImageUrl(img) {
    return cleanUrl(img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-srcset') || img.currentSrc || '');
  }

  function setImage(img, options) {
    var source = currentImageUrl(img);
    if (!source || !canResize(source)) return;
    var key = source + '|' + options.max + (options.keySuffix || '');
    if (img.getAttribute('data-uc-image-perf') === key) return;
    img.setAttribute('data-uc-image-perf', key);
    img.setAttribute('src', sizedUrl(source, options.max));
    img.setAttribute('srcset', srcset(source, options.widths));
    img.setAttribute('sizes', options.sizes);
    img.setAttribute('decoding', 'async');
    if (options.loading) img.setAttribute('loading', options.loading);
    if (options.width) img.setAttribute('width', options.width);
    if (options.height) img.setAttribute('height', options.height);
  }

  function optimizeFitGuide() {
    document.querySelectorAll('img.uc-fit-simple-image, img[src*="sketchdim.png"], img[data-src*="sketchdim.png"]').forEach(function (img) {
      setImage(img, {
        max: 960,
        widths: [480, 720, 960, 1200],
        sizes: '(max-width: 749px) calc(100vw - 16px), 760px',
        loading: 'lazy',
        keySuffix: '|fit-natural-v2'
      });
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.style.height = 'auto';
      img.style.aspectRatio = 'auto';
      img.style.objectFit = 'contain';
    });
  }

  function optimizeCartDrawer() {
    document.querySelectorAll(drawerSelector + ' img').forEach(function (img) {
      setImage(img, {
        max: 240,
        widths: [120, 180, 240, 320],
        sizes: '(max-width: 480px) 96px, 120px',
        loading: 'lazy',
        width: 160,
        height: 190
      });
    });
  }

  function optimizeLazyGallery() {
    document.querySelectorAll('img.lazyload[data-srcset*="/cdn/shop/files/"], img.lazyload[data-srcset*="cdn.shopify.com/s/files/"]').forEach(function (img) {
      if (img.closest('.productView, .productView-image, .productView-thumbnail, .productView-nav, .productView-for, .productView-media, .productView-img-container, .product-single__media, .product__media, .product-gallery')) return;
      if (img.closest('.productView-thumbnail')) return;
      var source = cleanUrl(img.getAttribute('data-srcset'));
      if (!source || !canResize(source) || /\s+\d+w/.test(img.getAttribute('data-srcset') || '')) return;
      img.setAttribute('data-srcset', srcset(source, [480, 720, 960, 1200, 1600]));
      img.setAttribute('data-sizes', 'auto');
      img.setAttribute('sizes', '(max-width: 749px) 100vw, 760px');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    });
  }

  function optimizeBundleBackgrounds() {
    document.querySelectorAll('.uc-bc-clean-chip-dot, .uc-bc-clean-swatch-dot').forEach(function (node) {
      var image = node.style && node.style.backgroundImage;
      if (!image || image === 'none') return;
      var match = image.match(/url\(["']?([^"')]+)["']?\)/);
      if (!match) return;
      var source = cleanUrl(match[1]);
      if (!source || !canResize(source)) return;
      var target = sizedUrl(source, node.classList.contains('uc-bc-clean-swatch-dot') ? 120 : 240);
      if (node.getAttribute('data-uc-bg-perf') === target) return;
      node.setAttribute('data-uc-bg-perf', target);
      node.style.backgroundImage = 'url("' + target + '")';
    });
  }

  function run() {
    optimizeFitGuide();
    optimizeCartDrawer();
    optimizeLazyGallery();
    optimizeBundleBackgrounds();
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      run();
    });
  }

  function bindObservers() {
    if (!window.MutationObserver) return;
    var drawer = document.querySelector(drawerSelector);
    var bundle = document.querySelector('[data-uc-bc-clean]');
    if (drawer) {
      new MutationObserver(schedule).observe(drawer, {
        childList: true,
        subtree: true
      });
    }
    if (bundle) {
      new MutationObserver(schedule).observe(bundle, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
    if (document.body) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
            var node = mutations[i].addedNodes[j];
            if (!node || node.nodeType !== 1) continue;
            if (node.matches && (node.matches(drawerSelector) || node.matches('[data-uc-bc-clean]') || node.matches('img'))) {
              schedule();
              return;
            }
            if (node.querySelector && node.querySelector(drawerSelector + ', [data-uc-bc-clean], img')) {
              schedule();
              return;
            }
          }
        }
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  function bind() {
    run();
    ['uc:cart:updated', 'uc:cart:open', 'uc:cart:refresh', 'cart-update', 'cart:updated', 'cart:refresh', 'ajaxCart:updated'].forEach(function (name) {
      document.addEventListener(name, schedule);
    });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest(drawerSelector + ', [data-uc-bc-clean]')) schedule();
    }, true);
    bindObservers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
